import requestConfig from 'config/requestExodus';
import {
  IPaywallPayload,
  IMultiplePayload,
  ICounterPayload,
} from 'features/paywall/types';
import { APIResponse } from '../../../@types/api-response';

const request = requestConfig(false);

const GET_ELIGIBILITY_STATUS = '/paywall/eligibility/check';
const POST_PAYWALL_COUNTER = '/paywall/counter/increment';

const getPaywallStatus = ({
  company,
  feature,
}: IPaywallPayload): Promise<APIResponse> => {
  const params: any = {
    features: feature,
  };

  if (company) {
    params.company = company;
  }

  return request.get(GET_ELIGIBILITY_STATUS, {
    params,
  });
};

const getMultipleStatus = (payload: IMultiplePayload): Promise<APIResponse> => {
  const { company, feature } = payload;

  const companyQs = company ? `company=${company}&` : '';
  const featuresQs = feature.map((f) => `features=${f}`).join('&');
  return request.get(`${GET_ELIGIBILITY_STATUS}?${companyQs}${featuresQs}`);
};

const addPaywallCounter = ({
  company,
  feature,
}: ICounterPayload): Promise<APIResponse> => {
  const body: any = {
    feature,
  };

  if (company) {
    body.company = company;
  }

  return request.post(POST_PAYWALL_COUNTER, body);
};

export default {
  getPaywallStatus,
  getMultipleStatus,
  addPaywallCounter,
};
